type PlanningCancellationReasonFieldProps = {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  label?: string;
  placeholder?: string;
};

export function PlanningCancellationReasonField({
  value,
  onChange,
  required = true,
  label = 'Motivo do cancelamento',
  placeholder = 'Descreva por que este item está sendo cancelado.',
}: PlanningCancellationReasonFieldProps) {
  return (
    <label className="block">
      <span className="erp-label">{label}</span>
      <textarea
        className="erp-input min-h-[80px]"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        required={required}
        maxLength={2000}
        placeholder={placeholder}
      />
    </label>
  );
}
